export const FEED_TYPE = 'feedType';
export const GRID_SIZE = 'gridSize';
